import { createEditableProps } from "@ludens-reklame/rubics-v3-react/util/fns";

interface Props {
  html: string;
  className?: string;
  editable?: boolean;
  path?: string;
}

export const RichText: React.FC<Props> = ({
  html,
  className,
  editable,
  path,
}) => {
  return (
    <div
      className={`rich-text${className ? ` ${className}` : ""}`}
      dangerouslySetInnerHTML={{ __html: html }}
      {...(editable && path ? createEditableProps("html", path) : {})}
    />
  );
};
